module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Site_Page":{"hooks.onSetPageOptions":[{"value":function (argument) {
var st, pt, description, keywords, title,
excludeTitlePrefix = this.getOption('excludeTitlePrefix');
if (!this.getOption('dynamicTitle') && !!fox.site.dl) {
st = fox.site.dl.getObjectValue('title') || 'MC';
pt = this.getOption('title');
document.title = ((excludeTitlePrefix === true) ? pt : (st + (pt ? ' | ' + pt : '')));
(description = document.querySelector('meta[name="description"]')) &&
description.setAttribute('content', this.getOption('description'));
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.Site_Page","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/pageTitle.js
// module id = 701
// module chunks = 4